<template>
  <section>
    <div class="mSociety">
      <title-bg></title-bg>
      <template v-if="0==currentIndex">
      <a-spin :spinning="info_loading" tip="Loading..." :delay="100" style="min-height:70px;">
        <a-descriptions title="我的信息" bordered :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }">
          <a-descriptions-item label="姓名">
            {{myinfo.user_name}}
          </a-descriptions-item>
          <a-descriptions-item label="会员编号">
            {{myinfo.id}}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话">
            {{myinfo.user_mobile}}
          </a-descriptions-item>
          <a-descriptions-item label="身份证号">
            {{myinfo.user_id_card}}
          </a-descriptions-item>
          <a-descriptions-item label="家庭住址" :span="2">
            {{myinfo.address ? myinfo.address : '无'}}
          </a-descriptions-item>
          <a-descriptions-item label="紧急联系人">
            {{myinfo.user_guardian_name}}
          </a-descriptions-item>
          <a-descriptions-item label="紧急联系人电话">
            {{myinfo.user_guardian_mobile}}
          </a-descriptions-item>
          <a-descriptions-item label="血型">
            {{myinfo.blood_type}}
          </a-descriptions-item>
          <a-descriptions-item label="过往病史">
            {{myinfo.medical_history ? myinfo.medical_history : '无'}}
          </a-descriptions-item>
          <a-descriptions-item label="参与协会" :span="2">
            {{myinfo.activity_name ? myinfo.activity_name.join('；') : ''}}
          </a-descriptions-item>
          <a-descriptions-item label="院内/外">
            {{1==myinfo.is_source ? '院内' : '院外'}}
          </a-descriptions-item>
          <a-descriptions-item label="离退休机构">
            {{1==myinfo.is_source ? myinfo.ins_name : ''}}
          </a-descriptions-item>
        </a-descriptions>
        <a-button type="primary" @click="setCurrentIndex(1)">修改信息</a-button>
      </a-spin>
      </template>
      <template v-else-if="1==currentIndex">
      <a-spin :spinning="options_loading" tip="Loading..." :delay="100" style="min-height:70px;">
        <h3 class="mSociety-title">请选择您参加的协会</h3>
        <div class="mSociety-list">
          <a-checkbox-group v-model="society">
            <a-row type="flex">
              <a-col flex="auto" v-for="(child, index) in options" :key="index">
                <a-checkbox :value="child.activity_id">
                  {{child.activity_name}}
                </a-checkbox>
                <a-icon @click="showDetail(child.activity_id)" type="info-circle" theme="twoTone" />
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
        <a-button type="primary" @click="selectActivity">确定</a-button>
        <a-modal :title="detail.activity_name" :visible="visible" @cancel="hideDetail" footer="">
          <p>{{ detail.activity_introduce }}</p>
        </a-modal>
      </a-spin>
      </template>
      <template v-else-if="2==currentIndex">
      <a-spin :spinning="modify_loading" tip="Loading..." :delay="100" style="min-height:70px;">
        <div class="modify">
          <a-form-model class="modify-info" :model="formInfo" ref="formInfo" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <h3 class="modify-title">个人信息</h3>
            <a-form-model-item label="姓名" prop="user_name" >
              <a-input placeholder="请输入姓名" v-model="formInfo.user_name" @blur="formDebug"/>
            </a-form-model-item>
            <a-form-model-item label="手机号" prop="user_mobile" >
              <a-input placeholder="请输入手机号" v-model="formInfo.user_mobile"/>
            </a-form-model-item>
            <a-form-model-item label="证件号" prop="user_id_card" >
              <a-input placeholder="请输入身份证号" v-model="formInfo.user_id_card"/>
            </a-form-model-item>
            <a-form-model-item label="血型" prop="blood_type" >
              <a-select placeholder="请选择类型" v-model="formInfo.blood_type">
                <a-select-option v-for="item in bloodTypes" :key="item.value">
                  {{item.value}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="过往病史" prop="medical_history" >
              <a-input placeholder="（若无此项，可不填写)" v-model="formInfo.medical_history"/>
            </a-form-model-item>
            <a-form-model-item label="院内/外" prop="is_source" >
              <a-select placeholder="请选择类型" v-model="formInfo.is_source">
                <a-select-option v-for="item in sources" :key="item.key">
                  {{item.value}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="离退休机构" prop="user_institute" v-if="1==formInfo.is_source">
              <a-auto-complete
                v-model="formInfo.user_institute"
                :data-source="institutes"
                placeholder="请选择离退休所在机构"
                @change="userInstituteChange"
              />
            </a-form-model-item>
            <a-form-model-item label="过往病史" prop="medical_history" >
              <a-input placeholder="（若无此项，可不填写)" v-model="formInfo.medical_history"/>
            </a-form-model-item>
            <a-form-model-item label="家庭住址" prop="address" >
              <a-input placeholder="请输入家庭住址" v-model="formInfo.address"/>
            </a-form-model-item>
            <h3 class="modify-title">紧急联系人信息</h3>
            <a-form-model-item label="姓名" prop="user_guardian_name" >
              <a-input placeholder="请输入紧急联系人姓名" v-model="formInfo.user_guardian_name" @blur="formDebug"/>
            </a-form-model-item>
            <a-form-model-item label="联系电话" prop="user_guardian_mobile" >
              <a-input placeholder="请输入紧急联系电话" v-model="formInfo.user_guardian_mobile"/>
            </a-form-model-item>
          </a-form-model>
          <a-button type="primary" @click="saveInfo">保存修改</a-button>
        </div>
      </a-spin>
      </template>
      <template v-else-if="3==currentIndex">
        <div class="success">
          <img src="../../../assets/image/success-icon.png" alt="" class="success-image">
          <span class="success-title">您的个人信息已修改</span>
          <a-button type="primary" @click="setCurrentIndex(0)" style="margin-bottom:10px">查看个人主页</a-button>
          <a-button type="button" @click="setCurrentIndex(1)">继续修改</a-button>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import TitleBg from '../../../components/TitileBg'
import { Society } from '../../../common/mine/Society'
export default {
  mixins: [Society],
  components: {
    TitleBg
  },
}
</script>
<style lang="less" scoped>
.mSociety{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-title{
    margin: 6vw 0 2.4vw;
    font-size: 4.76vw;
    font-weight:400;
    color:rgba(193,102,19,1);
    text-align: center;
  }
  &-list{
    padding: 5.6vw 0 5.6vw 8.8vw;
    border: 0.4vw solid #cccccc;
    border-radius: 3vw;
    & /deep/ .ant-col{
      margin: 0;
      height: 6vw;
      line-height: 6vw;
      width: 92%
    }
  }
  & /deep/ .ant-btn{
    margin: 5.6vw auto 9vw;
    width: 86vw;
    height: 11vw;
    font-size: 4.6vw;
    font-weight: 400;
    border-radius: 2.7vw;
    display: block;
    &-primary {
      color:rgba(255,255,255,1);
      background:rgba(193,102,19,1);
    }
  }
  .ant-descriptions {
    margin-top: 6vw;
  }
  & /deep/ .ant-descriptions-title {
    margin-bottom: 4vw;
    font-size: 4.36vw;
  }
  .modify{
    overflow: hidden;
    &-title{
      display: flex;
      align-items: center;
      margin-top: 3.2vw;
      height: 12vw;
      font-size:4vw;
      font-weight:bold;
      color:rgba(0,0,0,1);
      border-bottom: 0.53vw solid #004D9A;
      box-sizing: border-box;
      span{
        font-weight: normal;
        margin-left: 1.87vw;
        font-size: 3.47vw;
        i{
          color: #E60A0A;
        }
      }
    }
    & /deep/ .ant-form{
      &-item{
        margin-bottom: 2.67vw;
        &-label{
          display: flex;
          align-items: center;
          padding: 0;
          height: 9.33vw;
        }
        &-control-wrapper, &-control{
          height: 10.67vw;
          .ant-input{
            height: 10.67vw;
          }
        }
        &.radio-item{
          display: flex;
          align-items: center;
          .ant-form-item-control-wrapper, .ant-form-item-control{
            display: flex;
            align-items: center;
            height: 9.33vw;
          }
          .ant-form-item-label{
            width: 16vw;
          }
          &.veteran-item{
            .ant-form-item-label{
              width: 58vw;
            }
          }
        }
      }
    }
    &-area{
      border-top: 0.13vw solid #CCCCCC;
      &-title{
        margin-top: 2.67vw;
        display: flex;
        align-items: center;
        height: 9.33vw;
        font-size:3.47vw;
        font-weight:400;
        color:rgba(0,0,0,1);
        span:nth-child(2){
          margin-left: 4.93vw;
          font-size:3.47vw;
          font-weight:400;
          color:rgba(193,102,19,1);
        }
      }
      &-input{
        display: flex;
        flex-direction: column;
        & /deep/ .ant-btn{
          width:37.47vw;
          height:10.67vw;
          font-size:4vw;
          font-weight:400;
          color:rgba(255,255,255,1);
          border-radius:0.67vw;
        }
        &-item{
          margin-bottom: 3.87vw;
          width: 91.73vw;
          height: 10.67vw;
          & /deep/ .ant-input{
            height: 10.67vw;
          }
        }
      }
      &-btn{
        display: flex;
        align-items: center;
        height: 10.67vw;
        & /deep/ .ant-btn{
          width:37.47vw;
          height:10.67vw;
          font-size:4vw;
          font-weight:400;
          color:rgba(255,255,255,1);
          border-radius:0.67vw;
        }
        .continue{
          margin-left: 2.13vw;
          font-size:3.47vw;
          font-weight:400;
          text-decoration:underline;
          color:rgba(193,102,19,1);
        }
      }
    }
    &-textarea{
      display: flex;
      flex-direction: column;
      &-label{
        margin: 6.67vw 0 2.67vw;
        height: 3.47vw;
        font-size:3.47vw;
        font-weight:400;
        color:rgba(0,0,0,1);
      }
      & /deep/ .ant-input{
        font-size: 4vw;
        height:27.73vw;
        border-radius:0.67vw;
        resize: none;
      }
    }
    .sure-btn{
      margin: 8vw 0 10.27vw;
      width: 100%;
      height:10.67vw;
      font-size:3.73vw;
      font-weight:400;
      color:rgba(255,255,255,1);
      border-radius:0.67vw;
    }
  }
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    &-image{
      margin-top: 6vw;
      width: 53.94vw;
      height: 48vw;
    }
    &-title{
      margin: 6vw 0 2vw;
      height: 6vw;
      font-size: 4.76vw;
      font-weight: 400;
      color: #3995ff;
    }
  }
}
</style>
